import './CommunicationsTheme.scss';

import { IdelinkModuleTheme } from '../../../configs/IdeLinkTheme';
import communicationsIconBlack from '../assets/communication.svg';
import digitalMarketingListDefaultIcon from '../assets/digitalMarketings/default-img-digital-marketings-square.svg';
import communicationsEmptyIcon from '../assets/ic-communication-empty.svg';
import communicationsIconWhite from '../assets/ic-communication-white.svg';
import leafletsListDefaultIcon from '../assets/leaflets/default-img-leaflet-square.svg';
import partnershipsListDefaultIcon from '../assets/partnerships/default-img-partnership-square.svg';

export const CommunicationsTheme: IdelinkModuleTheme = {
    className: 'idelink-theme il-theme-communications',
    backgroundColor: '#fcb731', //* mango
    permissionIcon: communicationsIconBlack,
    permissionSelectedIcon: communicationsIconWhite,
    navbarIcon: communicationsIconWhite,
    emptyIcon: communicationsEmptyIcon,
};

export const DigitalMarketingsTheme: IdelinkModuleTheme = {
    className: 'idelink-theme il-theme-digitalMarketings',
    backgroundColor: '#002b6f', // marine-blue
    listDefaultIcon: digitalMarketingListDefaultIcon,
};

export const LeafletsTheme: IdelinkModuleTheme = {
    className: 'idelink-theme il-theme-leaflets',
    backgroundColor: '#f25940', //* pastel-red
    listDefaultIcon: leafletsListDefaultIcon,
};

export const PartnershipsTheme: IdelinkModuleTheme = {
    className: 'idelink-theme il-theme-partnerships',
    backgroundColor: '#0e967d', //* blue-green
    listDefaultIcon: partnershipsListDefaultIcon,
};
